module.exports = __webpack_public_path__ + "img/image_welcomelanding.ec99cd4b.png";